<template>
	<div class="mm-page-main">
		<div class="page-header">
			<div class="page-title">添加會員</div>
			<div @click="pageback" class="page-back">
				<svg class="icon svg-icon" aria-hidden="true">
				  <use xlink:href="#icon-back"></use>
				</svg>
			</div>
		</div>

		<div class="pagemain">
		
			
			
			<div class="form-group">
				
				<div class="form-group-content">

					<div class="mm-row">
						<div class="mm-col">
							<div class="mm-item mb20">
								<label class="mm-label">會員類別：</label>
								<el-radio-group @change="clienttype" v-model="type">
									<el-radio-button  label="0">個人</el-radio-button>
									<el-radio-button  label="1">企業</el-radio-button>
									<el-radio-button  label="2">行家</el-radio-button>
								</el-radio-group>
							</div>
						</div>
					</div>
					<component :is="clientpage"></component>
					
				</div>
			</div>

			
			
			
			
		</div>
	</div>
</template>

<script>
	import person from "./components/Person.vue";
	import company from "./components/Company.vue";
	import connoisseur from "./components/Connoisseur.vue";
	export default {
		components: {
			person,
			company,
			connoisseur
		},
		data() {
			return {
				type:0,
				clientpage:'person',
				
			};
		},
		methods: {
			pageback() {
				this.$router.go(-1);
			},
			clienttype(){
				if(this.type == '0'){
					this.clientpage = 'person';
				}else if(this.type == '1'){
					this.clientpage = 'company';
				}else if(this.type == '2'){
					this.clientpage = 'connoisseur';
				}
			}
		}

	};
</script>
<style scoped>
	


	

	

	
</style>
